package org.example.project.service

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All

object LoginUserApi {
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadUser(userId: String): All? {
        if (userId.isBlank()) return null
        val raw = runCatching {
            LumaticaApiManager.call("userverwaltung/${apiPart(userId)}")
        }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return null
        return runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()
    }

    suspend fun loadCompanyUser(firmenId: String, userId: String): All? {
        if (firmenId.isBlank() || userId.isBlank()) return null
        val raw = runCatching {
            LumaticaApiManager.call("userverwaltung/company-user/${apiPart(firmenId)}/${apiPart(userId)}")
        }.getOrDefault("")
        if (raw.isBlank() || raw == "null") return null
        return runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()
    }

    suspend fun saveUser(user: All): All? {
        if (user.id.isBlank()) return null
        val raw = runCatching { LumaticaApiManager.call(userSaveApi(user)) }.getOrDefault("")
        if (raw.isNotBlank() && raw != "null") {
            return runCatching { json.decodeFromString(All.AllNames.serializer(), raw) }.getOrNull()
                ?: loadUser(user.id)
        }
        return loadUser(user.id)
    }

    suspend fun saveCurrentLoginUser(transform: (All) -> All): All? {
        val currentUser = LoginService.getUser() ?: return null
        return saveUser(transform(currentUser))
    }

    fun version(): Long = GlobalManager.jsonTopicVersion("user.json")

    private fun userSaveApi(user: All): String =
        "userverwaltung/save-json/${apiPart(user.id)}/${apiPart(userSaveBody(user))}"

    private fun userSaveBody(user: All): String =
        buildJsonObject {
            put("id", JsonPrimitive(user.id))
            put("firmenId", JsonPrimitive(user.firmenId))
            put("personalnummer", JsonPrimitive(user.personalnummer))
            put("vorname", JsonPrimitive(user.vorname))
            put("nachname", JsonPrimitive(user.nachname))
            put("email", JsonPrimitive(user.email))
            put("rolle", JsonPrimitive(user.rolle))
            put("position", JsonPrimitive(user.position))
            put("bereich", JsonPrimitive(user.bereich))
            put("zugangDesktop", JsonPrimitive(user.zugangDesktop))
            put("zugangMobil", JsonPrimitive(user.zugangMobil))
            put("terminkalenderOnline", JsonPrimitive(user.terminkalenderOnline))
            put("datenschutzAkzeptiert", JsonPrimitive(user.datenschutzAkzeptiert))
            put("passwortVerifiziert", JsonPrimitive(user.passwortVerifiziert))
            put("terminkalenderIntern", JsonPrimitive(user.terminkalenderIntern))
            put("profilOnline", JsonPrimitive(user.profilOnline))
            put("profilIntern", JsonPrimitive(user.profilIntern))
            put("firma", JsonPrimitive(user.firma))
            put("kunde", JsonPrimitive(user.kunde))
            put("name", JsonPrimitive(user.name))
            put("kuerzel", JsonPrimitive(user.kuerzel))
            put("startbildschirm", JsonPrimitive(user.startbildschirm))
            put("sprache", JsonPrimitive(user.sprache.ifBlank { "de" }))
        }.toString()

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String
}
